module.exports = __webpack_public_path__ + "img/niews-8.1530ad85.jpeg";